import { render } from "./Column202503.vue?vue&type=template&id=1233ffce&scoped=true"
import script from "./Column202503.vue?vue&type=script&lang=js"
export * from "./Column202503.vue?vue&type=script&lang=js"

import "./Column202503.vue?vue&type=style&index=0&id=1233ffce&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1233ffce"]])

export default __exports__